<template>
  <section class="suggestion-container">
    <article  class="product-info is-flex is-align-items-center" 
              :class="{ 'mb-5': !source.quantityInCart }">
      <div class="thumbnail-container">
        <thumbnail :thumbnail-url="source.thumbnailUrl"
                    thumbnail-type="part"
                    :isWidget="isWidget"
                    class="is-48x48" />
      </div>
      <article class="info-text ml-3 mb-2">
        <p class="name-text">{{ source?.name }}</p>
        <p class="subtitle is-6 part-number" style="margin-bottom: 0;">
          {{ source?.partNumber }}
        </p>
        <p v-if="source.quantityInCart" class="tag is-primary is-medium">
          {{ $t('inCart') }}: {{ source.quantityInCart }}
        </p>
      </article>
    </article>
    <div class="cart-controls">
      <add-to-cart v-model:quantity="source.quantity"
                  :expanded="true"
                  :include-add-btn="false"
                  @update:quantity="updatePartSuggestionQuantity(source.id, $event)"/>
    </div>
  </section>
</template>

<script setup lang="ts">
import { inject } from "vue"
import { PartSuggestion } from "@/interfaces/library/part"
import AddToCart from "@/components/library/content/info/AddToCart.vue"
import Thumbnail from "@/components/common/StatelessThumbnail.vue"

//@ts-ignore
const { updatePartSuggestionQuantity } = inject("partSuggestionQuantity")

type PartSuggestionWithQuantity = PartSuggestion & {
  quantity: number,
  quantityInCart: number
}
type Props = {
  source: PartSuggestionWithQuantity,
  isWidget: boolean
}
defineProps<Props>()
</script>

<style scoped>
.suggestion-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px; /* Space between product info and cart controls */
}

.product-info {
  display: flex;
  align-items: center;
  width: calc(100% - 136px); /* Total width minus cart controls width and gap */
  max-width: 500px; /* Set a consistent max width */
}

.thumbnail-container {
  width: 48px;
  flex-shrink: 0;
}

.info-text {
  min-width: 0; /* Prevents text from causing overflow */
  max-width: calc(100% - 64px); /* Thumbnail width + margin */
}

.name-text, .part-number {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart-controls {
  flex-shrink: 0;
}
@media only screen and (max-width: 640px) {
  .cart-controls {
    width: 120px;
  }
}
</style>